import React, { useState } from "react";
import axios from "axios";
import Head from "next/head";
import styles from "../../signature.module.css";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import { FaFileUpload, FaKey } from "react-icons/fa";
import { BASE_URL_POST } from "../../../../constants/constants";
import Blog from "../../../../components/CalculatorBlogs/Blog";
import SignaturePopup from "../../../../components/SignaturePopup";
import PdfToolsLinks from "../../../../components/PdfToolsLinks";

const BlogData = [
  {
    id: 1,
    question: "What is Encrypt PDF Tool?",
    answer: (
      <div className="">
        <p className="">
          An Encrypt PDF Tool is a tool that allows you to secure your PDF
          documents by applying encryption methods. Encryption ensures that only
          authorized users with the correct password or decryption key can
          access the content of the PDF file.
        </p>
      </div>
    ),
  },
  {
    id: 2,
    question: "How to Use the Encrypt PDF Tool?",
    answer: (
      <div className="">
        <p className="">
          To use the Encrypt PDF Tool, you need to upload the PDF file you want
          to encrypt. Then, you can set a password or choose other encryption
          settings to protect the document. Once encrypted, the PDF file will
          require the specified password or key for access.
        </p>
      </div>
    ),
  },
  {
    id: 3,
    question: "Can I Decrypt an Encrypted PDF File?",
    answer: (
      <div className="">
        <p className="">
          Yes, if you have the correct password or decryption key, you can
          decrypt an encrypted PDF file. Decrypting the file will remove the
          encryption and allow you to access the content without any
          restrictions.
        </p>
      </div>
    ),
  },
  {
    id: 4,
    question: "Is Encrypting PDFs Secure?",
    answer: (
      <div className="">
        <p className="">
          Encrypting PDFs provides a secure way to protect sensitive
          information. However, it is crucial to use strong, unique passwords
          and encryption methods to ensure the security of your encrypted PDF
          documents.
        </p>
      </div>
    ),
  },
  {
    id: 5,
    question: "What Happens If I Forget the Password for an Encrypted PDF?",
    answer: (
      <div className="">
        <p className="">
          If you forget the password for an encrypted PDF, it can be challenging
          to regain access to the content. Some PDF encryption tools offer
          password recovery options, but it is essential to follow best
          practices and keep a record of your passwords to prevent such
          situations.
        </p>
      </div>
    ),
  },
];

function FileUpload() {
  const [file, setFile] = useState(null);
  const [password, setPassword] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState("");
  const [signaturePopup, setSignaturePopup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // const scrollToPreview = () => {
  //   const element = document.getElementById("password-field");
  //   if (element) {
  //     element.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  const handleDrop = (e) => {
    e.preventDefault();
    if (!e.dataTransfer.files[0]) return;
    const file = e.dataTransfer.files[0];
    setFile(file);
    setError("");
    // scrollToPreview();
  };

  const handleFileChange = async (e) => {
    if (!e.target.files[0]) return;
    const file = e.target.files[0];
    setFile(file);
    setError("");
    // scrollToPreview();
  };

  const encryptPdf = async () => {
    setError("");
    if (!file) {
      setError("Please choose a file");
      return;
    }

    if (file.name.split(".").pop() !== "pdf") {
      setError("Please choose a pdf file");
      return;
    }

    if (!password || password === "") {
      setError("Please enter password");
      return;
    }

    if (file.size > 30000000) {
      setError("File Size is too large(>30MB)");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("password", password);
    try {
      setDownloading(true);
      const response = await axios.post(
        `${BASE_URL_POST}encryptPdf`,
        formData,
        {
          responseType: "blob",
        },
      );
      // console.log(response)
      downloadFile(response.data);
    } catch (error) {
      setDownloading(false);
      if (error.response.data.type === "text/html") {
        const blobReader = new FileReader();
        blobReader.addEventListener("loadend", () => {
          setError(blobReader.result);
        });
        blobReader.readAsText(error.response.data);
        return;
      }
      setError(error.response.data);
    }
  };

  const downloadFile = (blob) => {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "encrypted.pdf";
    link.click();
    setDownloading(false);
    setSignaturePopup(true);
  };

  return (
    <>
      <div className="w-full mt-20 sm:mt-24">
        <Head>
          <meta charSet="utf-8" />
          <title>Encrypt PDF Tool - BoloForms</title>
          <meta
            name="description"
            content="Encrypt PDF Tool allows you to secure your PDF documents by applying encryption methods. Encryption ensures that only authorized users with the correct password or decryption key can access the content of the PDF file."
          />
          <meta
            name="keywords"
            content="encrypt pdf, encrypt pdf online, encrypt pdf file, encrypt pdf document, encrypt pdf file online, encrypt pdf file free, encrypt pdf free, encrypt pdf online free, encrypt pdf boloforms, encrypt pdf tool, encrypt pdf tool online, encrypt pdf, secure pdf, secure pdf online, secure pdf file, secure pdf document, secure pdf file online, secure pdf file free, secure pdf free, secure pdf online free, secure pdf boloforms, secure pdf tool, secure pdf tool online, secure pdf, password protect pdf, password protect pdf online, password protect pdf file, password protect pdf document, password protect pdf file online, password protect pdf file free, password protect pdf free, password protect pdf online free, password protect pdf boloforms, password protect pdf tool, password protect pdf tool online, password protect pdf, password protect pdf with password, password protect pdf with password online, password protect pdf with password tool"
          />
          <meta name="author" content="BoloForms" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <link
            rel="canonical"
            href="https://www.bolosign.com/signature/pdf-tools/encrypt-pdf"
          />
          <meta property="og:title" content="Decrypt PDF Tool - BoloForms" />
          <meta
            property="og:description"
            content="Encrypt PDF Tool allows you to secure your PDF documents by applying encryption methods. Encryption ensures that only authorized users with the correct password or decryption key can access the content of the PDF file."
          />
          <meta
            property="og:url"
            content="https://www.bolosign.com/signature/pdf-tools/encrypt-pdf"
          />
          <meta property="og:site_name" content="BoloForms" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:image:alt" content="BoloForms" />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="en_US" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@BoloForms" />
          <meta name="twitter:creator" content="@BoloForms" />
          <meta name="twitter:title" content="Decrypt PDF Tool - BoloForms" />
          <meta
            name="twitter:description"
            content="Encrypt PDF Tool allows you to secure your PDF documents by applying encryption methods. Encryption ensures that only authorized users with the correct password or decryption key can access the content of the PDF file."
          />
          <link
            rel="canonical"
            href="https://www.bolosign.com/signature/pdf-tools/encrypt-pdf"
          />
        </Head>

        <div className="">
          <div className="max-w-[1280px] mx-auto px-2 md:px-10 py-10 rounded-xl relative flex flex-col gap-20">
            <div className="text-violet-500 text-center">
              <h1 className="text-3xl md:text-6xl text-gray-800">
                Encrypt PDF Tool
              </h1>
              <p className="text-lg md:text-2xl mt-4 text-gray-600">
                Encrypt with a password to prevent others from copying,
                printing, and editing your PDF document.
              </p>
            </div>
            <div
              className="extraOutline p-4 bg-white bg-whtie mx-auto rounded-lg w-full md:w-[600px]"
              onDragEnter={(e) => e.preventDefault()}
              onDragOver={(e) => e.preventDefault()}
              onDragLeave={(e) => e.preventDefault()}
              onDrop={handleDrop}
            >
              <div className="file_upload px-2 md:px-20 py-5 md:py-14 relative border-4 border-dotted border-gray-300 rounded-lg">
                <FaFileUpload className="text-gray-400 w-20 md:w-32 mx-auto mb-6 md:mb-10 text-[80px] md:text-[120px]" />
                <div className="input_field flex flex-col w-full mx-auto text-center">
                  <label>
                    <input
                      onChange={handleFileChange}
                      className="text-sm cursor-pointer w-36 hidden"
                      type="file"
                      accept=".pdf"
                    />
                    <div className="text bg-violet-600 text-white text-xl border border-gray-300 rounded-xl font-semibold cursor-pointer py-3 md:py-4 hover:bg-indigo-500">
                      Upload PDF File
                    </div>
                  </label>

                  {/* <div className="title text-gray-500 uppercase text-lg md:text-xl">
                    or drop file here 
                  </div> */}
                  <p className="text-gray-600 text-md">
                    {`(Do not upload an already encrypted PDF file. Decrypt it using our Decrypt PDF Tool and then upload it here.)`}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {file && (
            <div id="password-field" className="password-field">
              <div className="w-fit mx-auto flex justify-center mb-1 relative">
                <input
                  className="w-full md:w-[400px] outline-none border-2 border-gray-300 rounded-lg px-4 py-2 text-xl"
                  type={showPassword ? "text" : "password"}
                  placeholder="Choose Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  name=""
                  id=""
                />
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2 text-violet-500 text-3xl cursor-pointer">
                  {showPassword ? (
                    <AiFillEyeInvisible
                      onClick={() => setShowPassword(false)}
                    />
                  ) : (
                    <AiFillEye onClick={() => setShowPassword(true)} />
                  )}
                </div>
              </div>
              {error && (
                <p className="text-red-500 text-center text-xl">{error}</p>
              )}
              <div className="w-full mt-4">
                <button
                  onClick={encryptPdf}
                  className="bg-violet-600 mx-auto w-[200px] px-2 py-2 text-lg rounded-lg font-semibold text-white flex items-center justify-center gap-4 hover:bg-violet-400"
                >
                  {downloading ? (
                    <div
                      className={`flex items-center text-white space-x-2 ${styles.loader}`}
                    >
                      <div className="">Encrypting</div>
                      <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
                      <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
                      <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
                    </div>
                  ) : (
                    <>
                      Encrypt PDF <FaKey />
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
          {signaturePopup && (
            <SignaturePopup
              onPopupClose={() => setSignaturePopup(false)}
              source="ENCRYPT_PDF"
            />
          )}

          <div className="mt-28">
            <div className="mb-20">
              <PdfToolsLinks />
            </div>
            <Blog heading="Encrypt PDF Tool FAQs" BlogData={BlogData} />
          </div>
        </div>
      </div>
    </>
  );
}

export default FileUpload;
